/* Sam's Fragrances search synonyms (2026-09-25). Rewrites common misspellings / Arabic words to the
   catalogue term before the query reaches Shopify. Whole-word only. Deliberately NOT mapped: "misk"
   (Rasasi Oud Al Misk), "ambre", "latifa" - real product words. */
(function () {
  'use strict';
  var SYN = {
    oud: ['ood', 'oudh', 'aoud', 'oodh', 'عود'],
    bakhoor: ['bukhoor', 'bakhour', 'bakhur', 'bokhoor', 'بخور'],
    musk: ['mosk', 'musc', 'مسك'],
    amber: ['ambar', 'عنبر'],
    vanilla: ['vanila', 'vanella', 'فانيلا'],
    rose: ['ورد'],
    perfume: ['عطر']
  };
  var MAP = [];
  Object.keys(SYN).forEach(function (c) { SYN[c].forEach(function (v) { MAP.push([v.toLowerCase(), c]); }); });
  MAP.sort(function (a, b) { return b[0].length - a[0].length; });
  function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function normalise(q) {
    if (!q) return q;
    var out = ' ' + q.toLowerCase() + ' ', changed = false;
    MAP.forEach(function (p) {
      var re = new RegExp('(^|[\\s,.;:!?()\\-])' + esc(p[0]) + '(?=[\\s,.;:!?()\\-]|$)', 'g');
      if (re.test(out)) { out = out.replace(re, '$1' + p[1]); changed = true; }
    });
    return changed ? out.trim().replace(/\s+/g, ' ') : q;
  }
  window.__searchNormalise = normalise;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/search') === -1) return;
    var i = f.querySelector('input[name="q"]');
    if (i) { var x = normalise(i.value); if (x !== i.value) i.value = x; }
  }, true);
  var of = window.fetch;
  if (of) {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url);
        if (url && url.indexOf('/search/suggest') !== -1) {
          var u = new URL(url, location.origin), q = u.searchParams.get('q'), x = normalise(q);
          if (q && x !== q) { u.searchParams.set('q', x); input = typeof input === 'string' ? u.pathname + u.search : new Request(u.pathname + u.search, input); }
        }
      } catch (err) {}
      return of.call(this, input, init);
    };
  }
})();
